<template>
    <div class="reserva-wrapper">
      <div class="container-fluid py-4 overflow-auto">
        <div class="card p-4 shadow-sm h-100">
          <CalendarioReservas />
          <hr class="my-4" />
         
        </div>
      </div>
    </div>
  </template>
  
  
  
  <script>
  import CalendarioReservas from '@/components/calendarioreservas.vue'

  
  export default {
    name: 'VistaReserva',
    components: {
      CalendarioReservas
    }
  }
  </script>
  
  <style scoped>
  /* 🔧 CORRECCIÓN PARA MÓVIL */
  @media (max-width: 576px) {
    .card {
      border-radius: 0;
      box-shadow: none;
    }
  }
  </style>
  